import { Obstruction } from '../domain';
import BaseView from './BaseView';

export default class ObstructionView extends BaseView {

    declare model: Obstruction;

    protected make(): void {

    }
    protected bind(): void {

    }
}
